var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stack',[_c('onboarding-header',{ref:"header",attrs:{"region-data":_vm.regionData}}),_c('div',{staticClass:"flex-grow"},[_vm._t("default")],2),_c('login-site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }